// extracted by mini-css-extract-plugin
module.exports = {"background":"Bp1sqyqU _3AXrwpVi _323rGRHm _2BQ8VZ00","heading":"_3w106LCs dUMdRZQH _1TGOHcy4"};